<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-credit-card" />
            Payment Roya
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="createInvoice">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white mb-2">
                <b-input-group-prepend class="custom-prepend-middle">
                  <b-form-select class="period-by-select" v-model="table.periodBy" :options="table.periodOptions" @change="onChangeFilterDate"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="table.periodStart" 
                    :min="table.minPeriodStart"
                    :max="table.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="getTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="table.periodEnd" 
                    :min="table.minPeriodEnd"
                    :max="table.maxPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    class="custom-label-date"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="getTableItems()"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-input maxlength="50" v-if="table.filterType == 'contractNo' || table.filterType == 'invoiceNoPnbp' || table.filterType == 'invoiceNoNotary'" type="text" placeholder="Search" v-model="table.filterValue" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"></b-form-input>
                  <!-- <b-form-select v-else-if="table.filterType == 'contractType'" v-model="table.filterValue" :options="table.filterValueContractTypeOptions" style="min-width: 206.5px;"></b-form-select> -->
                  <b-form-select v-else-if="table.filterType == 'paymentStatusNotary' || table.filterType == 'paymentStatusPnbp'" v-model="table.filterValue" :options="table.filterValuePaymentStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="table.filterValue"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
            <!-- <b-btn @click="testAction">Test</b-btn> -->
          </CCol>
          <CCol class="mr-4" style="text-align: right;">
              <p class="mt-2" style="font-weight: bold; font-size: 17px;">Kontrak RCE tanpa invoice: {{ Number(contractCountWithoutInvoice).toLocaleString('id') }}</p>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(contractNo)="row">
                  <span v-if="$helper.isEmpty(row.value)">-</span>
                  <span v-else>{{ row.value }}</span>
              </template>
              <template #cell(notaryName)="row">
                  <span v-if="$helper.isEmpty(row.value)">-</span>
                  <span v-else>{{ row.value }}</span>
              </template>
              <template #cell(contractType)="row">
                  <span v-if="$helper.isEmpty(row.value)">-</span>
                  <span v-else>
                    <span v-if="row.value == 'F'">Fiducia</span>
                    <span v-else-if="row.value == 'R'">Roya</span>
                    <span v-else>APHT</span>
                  </span>
              </template>
              <template #cell(assignmentDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(applicationDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(invoiceNoPnbp)="row">
                  <span v-if="$helper.isEmpty(row.value)">-</span>
                  <span v-else>
                    {{ row.value }}
                    <br />
                    <CBadge color="danger" v-if="$helper.isEmpty(row.item.paymentStatusPnbp) || row.item.paymentStatusPnbp == 'U'">UNPAID</CBadge>
                    <CBadge color="success" v-else>PAID</CBadge>
                  </span>
              </template>
              <template #cell(invoiceNoNotary)="row">
                  <span v-if="$helper.isEmpty(row.value)">-</span>
                  <span v-else>
                    {{ row.value }}
                    <br />
                    <CBadge color="danger" v-if="$helper.isEmpty(row.item.paymentStatusNotary) || row.item.paymentStatusNotary == 'U'">UNPAID</CBadge>
                    <CBadge color="success" v-else>PAID</CBadge>
                  </span>
              </template>
              <template #cell(action)="row">
                <CButton v-if="!$helper.isEmpty(row.item.invoiceNoPnbp)" size="sm" color="primary" title="Detail Invoice" class="btn-icon" @click="$router.push({ name: 'Invoice Roya Detail', params: { invoiceType: 'pnbp', contractId: row.item.contractId} })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
                <CButton v-else-if="!$helper.isEmpty(row.item.invoiceNoNotary)" size="sm" color="primary" title="Detail Invoice" class="btn-icon" @click="$router.push({ name: 'Invoice Roya Detail', params: { invoiceType: 'notary', contractId: row.item.contractId} })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'InvoiceRoyaList',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      contractCountWithoutInvoice: 0,

      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',

      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "notaryName", label: "Nama Notaris", sortable: true},
          {key: "contractType", label: "Tipe Kontrak", sortable: true},
          {key: "assignmentDate", label: "Tanggal Assign", sortable: true},
          {key: "applicationDate", label: "Tanggal Invoice", sortable: true},
          {key: "invoiceNoPnbp", label: "Invoice PNBP", sortable: true},
          {key: "invoiceNoNotary", label: "Invoice Notaris", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [
          // {
          //   contractNo: '0987654',
          //   notaryName: 'Agus',
          //   contractType: 'A',
          //   assignmentDate: '2021-12-12',
          //   invoiceNoPnbp: '123456',
          //   invoiceNoNotary: '654321',
          //   paymentStatusPnbp: 'U',
          //   paymentStatusNotary: 'P'
          // }
        ],

        filterType: "contractNo",
        filterOptions: [
          { value: "contractNo", text: "No. Kontrak" },
          { value: "notaryName", text: "Nama Notaris" },
          // { value: "contractType", text: "Tipe Kontrak" },
          { value: "invoiceNoPnbp", text: "Invoice PNBP" },
          { value: "invoiceNoNotary", text: "Invoice Notaris" },
          { value: "paymentStatusPnbp", text: "Status Inv. PNBP" },
          { value: "paymentStatusNotary", text: "Status Inv. Notaris" },
        ],
        filterValue: "",
        filterValueContractTypeOptions: [
          { value: "F", text: "Fiducia" },
          { value: "R", text: "Roya" },
          // { value: "A", text: "APHT" },
        ],
        filterValuePaymentStatusOptions: [
          { value: "U", text: "Unpaid" },
          { value: "P", text: "Paid" },
        ],
        periodOptions: [
          { value:"assignmentDate", text: "Tanggal Assign" },
          { value:"applicationDate", text: "Tanggal Invoice" }
        ],
        periodBy: "assignmentDate",
        // periodStart: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        periodStart: null,
        minPeriodStart: '',
        maxPeriodStart: today,
        periodEnd: null,
        minPeriodEnd: '',
        maxPeriodEnd: today,

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    onChangeFilterDate() {
      if (!this.$helper.isEmpty(this.table.periodStart) && !this.$helper.isEmpty(this.table.periodEnd)) {
        this.getTableItems()
      }
    },

    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.table.minPeriodEnd = this.table.periodStart
      this.table.maxPeriodEnd = this.$moment(this.table.periodStart).add(1, 'years').format('YYYY-MM-DD')
    },
    onContextPeriodEnd() {
      this.table.maxPeriodStart = this.table.periodEnd
      this.table.minPeriodStart = this.$moment(this.table.periodEnd).subtract(1, 'years').format('YYYY-MM-DD')
    },

    getContractCountWithoutInvoice() {
      // URL builder
      let getUrl = "/payment/countContractRCE"
      let params = {contractType: 'R'}

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.contractCountWithoutInvoice = response.data.data
        } else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Jumlah Kontrak RCE Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Jumlah Kontrak RCE Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Jumlah Kontrak RCE Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
    },

    filterTable(event) {
      event.preventDefault()

      this.getTableItems(this.table.currentPage)
    },

    // testAction() {
    //   console.warn(this.table.filterValue)
    //   console.warn(this.table.filterValueContractTypeOptions)
    // },

    createInvoice() {
      this.$router.push({ name: 'Invoice Roya Add' })
    },

    onChangeFilterType() {
      if (this.table.filterType == "contractType") {
        this.table.filterValue = "F"
      } else if (this.table.filterType == "paymentStatusNotary" || this.table.filterType == "paymentStatusPnbp") {
        this.table.filterValue = "U"
      } else{
        this.table.filterValue = null
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      this.getTableItems()
    },
  
    onPageChange(newPage) {
      this.getTableItems(newPage)
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      this.getTableItems(this.table.currentPage)
    },
  
    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/payment/getAllContractRoya"

      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = this.table.filterValue
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }
      if (!this.$helper.isEmpty(this.table.periodStart) && !this.$helper.isEmpty(this.table.periodEnd)) {
        params['periodBy'] = this.table.periodBy
        params['periodStart'] = this.table.periodStart
        params['periodEnd'] = this.table.periodEnd
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterInvoiceRoyaPeriodBy", this.table.periodBy)
          sessionStorage.setItem("filterInvoiceRoyaPeriodStart", this.table.periodStart)
          sessionStorage.setItem("filterInvoiceRoyaPeriodEnd", this.table.periodEnd)
          sessionStorage.setItem("filterInvoiceRoyaType", this.table.filterType)
          sessionStorage.setItem("filterInvoiceRoyaValue", this.table.filterValue)
          this.table.items = response.data.data.data
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },
  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRoyaPeriodBy"))){
      this.table.periodBy = sessionStorage.getItem("filterInvoiceRoyaPeriodBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRoyaPeriodStart"))){
      this.table.periodStart = sessionStorage.getItem("filterInvoiceRoyaPeriodStart")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRoyaPeriodEnd"))){
      this.table.periodEnd = sessionStorage.getItem("filterInvoiceRoyaPeriodEnd")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRoyaType"))){
      this.table.filterType = sessionStorage.getItem("filterInvoiceRoyaType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoiceRoyaValue"))){
      this.table.filterValue = sessionStorage.getItem("filterInvoiceRoyaValue")
    }
    this.getTableItems()

    this.getContractCountWithoutInvoice()

    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  },
}
</script>

<style scoped>
.period-by-select {
  height: 41px;
}
</style>
